import {Note, NoteDisplay, NoteManager} from "./note.js";
import {IDBStore} from "./store/idb.js";

// Register service worker for PWA functionality
if ('serviceWorker' in navigator) {
    window.addEventListener('load', () => {
        navigator.serviceWorker.register('/sw.js')
            .then(registration => {
                console.log('Service Worker registered with scope:', registration.scope);
            })
            .catch(error => {
                console.error('Service Worker registration failed:', error);
            });
    });
}

const container = document.querySelector(".notes");
const manager = new NoteManager(
    new IDBStore("jotting", "notes"),
);

function displayNote(note: Note) {
    const display = new NoteDisplay(note);
    container?.prepend(display.el);
}

// Initialize the app after the database is ready
async function initApp() {
    await navigator.storage.persist();

    try {
        // Wait for the manager to be fully initialized
        await manager.ready;

        // Display existing notes
        manager.notes.forEach(note => displayNote(note));

        document.addEventListener('paste', async (event) => {
            const t = event.target;
            if (!t
                || ("contentEditable" in t && t.contentEditable)
                || t instanceof HTMLInputElement
                || t instanceof HTMLTextAreaElement) {
                return;
            }

            event.preventDefault();
            const pastedText = event.clipboardData?.getData('text/html');
            if (pastedText) {
                try {
                    const note = await manager.create();
                    note.value = pastedText;
                    displayNote(note);
                } catch (error) {
                    console.error("Error creating note from paste:", error);
                }
            }
        });

        // Set up event listener for creating new notes
        document.querySelector("#new-note")?.addEventListener("click", async () => {
            try {
                const note = await manager.create();
                displayNote(note);
            } catch (error) {
                console.error("Error creating note:", error);
            }
        });
    } catch (error) {
        console.error("Error initializing app:", error);
    }
}

// Start the app
initApp();
